module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manager_review_desc":"This review is published by %{brandName} administrator."}}')
  delete Component.options._Ctor
}
